import React, { useState } from 'react';
import styled from 'styled-components';
import { ACCENT_COLOR } from '../styles/style';
import ImgMe from '../images/me.jpg';
import { smoothScrollTo } from '../utils/scroll';
import useActiveSection from '../hooks/useActiveSection';

const navItems = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'O mnie' },
  { id: 'services', label: 'Oferta' },
  { id: 'portfolio', label: 'Portfolio' },
  { id: 'contact', label: 'Kontakt' },
];

const socialLinks = [
  {
    name: 'Facebook',
    iconClass: 'fab fa-square-facebook',
    url: 'https://www.facebook.com/wojtek.talanda',
  },
  {
    name: 'WhatsApp',
    iconClass: 'fab fa-whatsapp',
    url: 'https://wa.me/48504705724',
  },
  {
    name: 'Email',
    iconClass: 'fas fa-envelope',
    url: 'mailto:talanda.wojciech@gmail.com',
  },
];

const NavbarContainer = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #1a1a1a;
  z-index: 999;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  @media (min-width: 1024px) {
    display: none;
  }
`;

const Logo = styled.div`
  display: flex;
  align-items: center;
  img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 3px solid #343a40;
  }
  span {
    margin-left: 10px;
    color: white;
    font-weight: bold;
  }
`;

const Hamburger = styled.div`
  cursor: pointer;
  span {
    display: block;
    width: 25px;
    height: 3px;
    margin: 5px;
    background-color: white;
    transition: 0.3s;
  }
`;

const Menu = styled.div`
  position: fixed;
  top: 0;
  z-index: 2;
  left: ${({ open }) => (open ? '0' : '-100%')};
  width: 100%;
  height: 100vh;
  background-color: #1a1a1a;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: left 0.3s ease-in-out;
`;

const NavItem = styled.button`
  background: none;
  border: none;
  color: ${({ active }) => (active ? ACCENT_COLOR : '#ffffff')};
  font-size: 1.2rem;
  margin: 1rem 0;
  cursor: pointer;
  font-family: Poppins;
  font-weight: 500;
  &:hover {
    color: ${ACCENT_COLOR};
  }
`;

const Social = styled.div`
  display: flex;
  gap: 20px;
  margin-top: 2rem;
  a {
    color: #ffffff99;
    font-size: 1.5rem;
    transition: color 0.3s;
    &:hover {
      color: ${ACCENT_COLOR};
    }
  }
`;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const sectionIds = navItems.map((item) => item.id);
  const active = useActiveSection(sectionIds);

  const handleClick = (id) => {
    smoothScrollTo(id);
    setOpen(false);
  };

  return (
    <>
      <NavbarContainer>
        <Logo>
          <img src={ImgMe} alt="Wojciech Tałanda" />
          <span>Wojciech Tałanda</span>
        </Logo>
        <Hamburger onClick={() => setOpen(!open)}>
          <span />
          <span />
          <span />
        </Hamburger>
      </NavbarContainer>
      <Menu open={open}>
        {navItems.map(({ id, label }) => (
          <NavItem
            key={id}
            onClick={() => handleClick(id)}
            active={active === id}
          >
            {label}
          </NavItem>
        ))}
        <Social>
          {socialLinks.map(({ name, iconClass, url }) => (
            <a
              key={name}
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={name}
            >
              <i className={iconClass}></i>
            </a>
          ))}
        </Social>
      </Menu>
    </>
  );
};

export default Navbar;
